import { useCallback, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { bindActionCreators } from 'redux';

import { EntityDetailActions } from 'actions';
import { CAMPAIGNS_MARKETING } from 'constants/Entities';
import EditFilledIcon from 'components/SvgIcons/EditFilled';
import colors from 'constants/colors';
import { ensureRoute } from 'utils/routes';
import { getLiteral } from 'utils/getLiteral';
import { publish } from 'lib/EventBuser';
import { REFRESH_TABLE } from 'lib/events';

import {
    MARKETING_CAMPAIGN_STATUS,
    normalizeMarketingCampaignStatusId,
} from '../utils/marketingCampaignStatus';

const DETAIL_WIDTH = '1150px';
const DETAIL_CLASS_NAME = 'fm-marketing-campaign-entity-detail';

/**
 * Configuración del detalle de campaña marketing para {@link EntityDetail}.
 * Opciones de cabecera (editar / eliminar) y constantes de layout.
 */
const useMarketingCampaignsDetail = () => {
    const dispatch = useDispatch();
    const closeDetail = useMemo(
        () => bindActionCreators(EntityDetailActions, dispatch).close,
        [dispatch],
    );

    const getOptions = useCallback(
        (data) => {
            if (!data?.id) {
                return [];
            }

            const statusId = normalizeMarketingCampaignStatusId(data.status);
            const canDelete =
                statusId === MARKETING_CAMPAIGN_STATUS.DRAFT ||
                statusId === MARKETING_CAMPAIGN_STATUS.SCHEDULED;

            const options = [
                {
                    el: <EditFilledIcon color={colors.grey[500]} />,
                    action: () => {
                        closeDetail({ purge: true, purgeTabs: true });
                        ensureRoute(`${CAMPAIGNS_MARKETING.route}/edit/${data.id}`);
                    },
                    tooltip: getLiteral('action_edit'),
                    className: 'fm-entity-detail__option-edit',
                },
            ];

            if (canDelete) {
                options.push('delete');
            }

            return options;
        },
        [closeDetail],
    );

    const onDeleteEntity = useCallback(() => {
        publish(`${REFRESH_TABLE}_${CAMPAIGNS_MARKETING.entity}`);
    }, []);

    return {
        className: DETAIL_CLASS_NAME,
        entity: CAMPAIGNS_MARKETING,
        getOptions,
        onDeleteEntity,
        width: DETAIL_WIDTH,
    };
};

export default useMarketingCampaignsDetail;
